import { useMutation } from '@tanstack/react-query';
import useGlynt from '../../hooks/useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { IRulesetDryRunRequest } from '../../../types/ruleset-types';

interface DryRunRulesetParams {
  dataPoolId: string;
  rulesetId: string;
  data: IRulesetDryRunRequest;
}

export function useDryRunRuleset(callbacks?: IRQCallbacks) {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async ({ dataPoolId, rulesetId, data }: DryRunRulesetParams) =>
      (await glynt).ruleset.dryRun(dataPoolId, rulesetId, data),
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
    onMutate: callbacks?.onMutate,
    onSettled: callbacks?.onSettled,
  });
}
